export default class  GeneralLedgerActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_GENERALLEDGER='GET_HELPER_GENERALLEDGER';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static PRINT_GENERALLEDGER='PRINT_GENERALLEDGER';
  static BEFORE_PRINT_GENERALLEDGER='BEFORE_PRINT_GENERALLEDGER';
  static submit(){
    return {
      type:  GeneralLedgerActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type:  GeneralLedgerActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type:  GeneralLedgerActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type:  GeneralLedgerActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type:  GeneralLedgerActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type:  GeneralLedgerActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type:  GeneralLedgerActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type:  GeneralLedgerActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type:  GeneralLedgerActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type:  GeneralLedgerActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type:  GeneralLedgerActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type:  GeneralLedgerActions.GET_HELPER_GENERALLEDGER,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type:  GeneralLedgerActions.ERROR_SERVER,
      payload: error
    };
  }
  static beforePrint(){
    return {
      type: GeneralLedgerActions.BEFORE_PRINT_GENERALLEDGER,
    };
  }
  static print(printGeneralLedger){
    return {
      type: GeneralLedgerActions.PRINT_GENERALLEDGER,
      payload: printGeneralLedger
    };
  }
}